import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Table, Spinner, Alert } from 'react-bootstrap';
import api from '../../config/api';

const AssetManager = () => {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  // Form state
  const [editingAsset, setEditingAsset] = useState(null);
  const [formData, setFormData] = useState({
    asset_name: '',
    asset_id: '',
    asset_image: null
  });

  // Assetleri getir
  const fetchAssets = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/filter-assets');
      setAssets(response.data);
    } catch (err) {
      setError('Assetler yüklenirken bir hata oluştu');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssets();
  }, []);

  // Form değişikliklerini handle et
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'asset_image') {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  // Asset ekle veya güncelle
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('asset_name', formData.asset_name);
      formDataToSend.append('asset_id', formData.asset_id);
      if (formData.asset_image) {
        formDataToSend.append('asset_image', formData.asset_image);
      }

      let response;
      if (editingAsset) {
        response = await api.put(`/admin/filter-assets/${editingAsset.id}`, formDataToSend);
        setSuccess('Asset başarıyla güncellendi');
      } else {
        response = await api.post('/admin/filter-assets', formDataToSend);
        setSuccess('Asset başarıyla eklendi');
      }

      // Formu sıfırla
      setFormData({ asset_name: '', asset_id: '', asset_image: null });
      setEditingAsset(null);
      
      // Listeyi güncelle
      fetchAssets();
    } catch (err) {
      setError(err.response?.data?.error || 'Bir hata oluştu');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Asset düzenleme moduna geç
  const handleEdit = (asset) => {
    setEditingAsset(asset);
    setFormData({
      asset_name: asset.asset_name,
      asset_id: asset.asset_id,
      asset_image: null
    });
  };

  // Asset sil
  const handleDelete = async (id) => {
    if (!window.confirm('Bu asseti silmek istediğinizden emin misiniz?')) return;

    try {
      setLoading(true);
      await api.delete(`/admin/filter-assets/${id}`);
      setSuccess('Asset başarıyla silindi');
      fetchAssets();
    } catch (err) {
      setError('Asset silinirken bir hata oluştu');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid>
      <h2 className="mb-4">{editingAsset ? 'Asset Düzenle' : 'Yeni Asset Ekle'}</h2>
      
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      <Form onSubmit={handleSubmit} className="mb-4">
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Asset Adı</Form.Label>
              <Form.Control
                type="text"
                name="asset_name"
                value={formData.asset_name}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Asset ID</Form.Label>
              <Form.Control
                type="text"
                name="asset_id"
                value={formData.asset_id}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Görsel</Form.Label>
              <Form.Control
                type="file"
                name="asset_image"
                onChange={handleInputChange}
                accept="image/*"
                required={!editingAsset}
              />
            </Form.Group>
          </Col>
        </Row>
        <Button type="submit" disabled={loading}>
          {loading ? (
            <Spinner animation="border" size="sm" />
          ) : editingAsset ? (
            'Güncelle'
          ) : (
            'Ekle'
          )}
        </Button>
        {editingAsset && (
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              setEditingAsset(null);
              setFormData({ asset_name: '', asset_id: '', asset_image: null });
            }}
          >
            İptal
          </Button>
        )}
      </Form>

      <h3 className="mb-3">Asset Listesi</h3>
      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Asset Adı</th>
            <th>Asset ID</th>
            <th>Görsel</th>
            <th>İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {assets.map(asset => (
            <tr key={asset.id}>
              <td>{asset.id}</td>
              <td>{asset.asset_name}</td>
              <td>{asset.asset_id}</td>
              <td>
                <img
                  src={asset.asset_image}
                  alt={asset.asset_name}
                  style={{ maxHeight: '50px' }}
                />
              </td>
              <td>
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2"
                  onClick={() => handleEdit(asset)}
                >
                  Düzenle
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(asset.id)}
                >
                  Sil
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default AssetManager; 